import { ProvideAccountOverview } from "./AccountOverview";
import { ProvideAccountSettings } from "./AccountSettings";
import { ProvideAuth } from "./Auth";
import { ProvideTheme } from "./Theme";

function ContextContainer({ children }) {
  return (
    <ProvideTheme>
      <ProvideAuth>
        <ProvideAccountOverview>
          <ProvideAccountSettings>{children}</ProvideAccountSettings>
        </ProvideAccountOverview>
      </ProvideAuth>
    </ProvideTheme>
  );
}

export default ContextContainer;
